<div class="button-item-wrap">

  <div
    class="button"
    [ngStyle]="{'background-image': 'url(' + (label.foto || 'assets/img/empty-img/no_image.png') + ')'}"
  >
    <div class="background-blur" (click)="clickBtn.emit()"></div>

    <div class="icon-wrap">
      <div class="icon-fav-wrap" (click)="clickFavBtn.emit()">
        <yu-icon [color]="label.favorito ? 'warning' : 'dark'" name="star"></yu-icon>
      </div>

      <div class="icon-options-wrap" (click)="clickOptionsBtn.emit()">
        <yu-icon color="dark" weight="light" name="dots-three-vertical"></yu-icon>
      </div>
    </div>
  </div>

  <div class="title">{{ label.nombre }}</div>

  <div
    class="expiration-date"
    [ngClass]="{'is-expired': isExpired}"
  >
    {{ (label.fecha_caducidad | date: 'EEEE, dd MMM yyyy') | titlecase }}
  </div>

</div>
